new Swiper('.review-slider', {
  slidesPerView: 5,
  spaceBetween: 0,
  loop: true, 
  allowTouchMove: true, 
  speed: 5000, 
  autoplay: {
    delay: 0, 
    disableOnInteraction: false,
  },
  freeMode: true,
  freeModeMomentum: false,
  breakpoints: {
    1: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 20,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1500: {
      slidesPerView: 4.4,
      spaceBetween: 20,
    },
  },
});